const userAgentOptions = ['KBC-Android', 'KBC-iOS'];

export function isKbcApp(): boolean {
  return userAgentOptions.filter((agent: string) => navigator.userAgent.includes(agent)).length > 0;
}

export function isKbcIos(): boolean {
  return userAgentOptions.filter(() => navigator.userAgent.includes('KBC-iOS')).length > 0;
}
